import React from "react";
import YouTube from "react-youtube";

const videoIds = ["HuhRn4sRQ3o", "wjWcHwQ4PLg", "gVGgTcKBPEk", "grNfsaATRsY"];

const WorkInAction = () => {
  return (
    <section className="w-full">
      <div className="maxContainer">
        <div className="grid items-center justify-center gap-8 mt-12 ss:grid-cols-2">
          {videoIds.map((id, index) => (
            <div
              className="flex justify-center w-full h-full min-h-[329px] bg-black"
              key={index}
            >
              <YouTube
                videoId={id}
                opts={{
                  height: "100%",
                  width: "100%",
                  playerVars: {
                    autoplay: 1,
                    mute: 1,
                    loop: 1,
                    playlist: id,
                  },
                }}
                className="w-full min-h-[329px]"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WorkInAction;
